module.exports = __webpack_public_path__ + "static/media/002_datacenter.6d122c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/google/002_datacenter.png
// module id = 460
// module chunks = 0